import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { useLang } from "@/context/LangContext";

// WhatsApp icon (brand glyph) — lucide has no WhatsApp mark.
const WhatsAppIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.29-.15-1.7-.84-1.96-.93-.26-.1-.45-.15-.64.14-.19.29-.74.93-.9 1.12-.17.19-.33.22-.62.07-.29-.15-1.22-.45-2.33-1.44-.86-.77-1.44-1.72-1.61-2.01-.17-.29-.02-.45.13-.6.13-.13.29-.34.44-.51.15-.17.19-.29.29-.48.1-.19.05-.36-.02-.51-.07-.15-.64-1.55-.88-2.12-.23-.56-.47-.48-.64-.49l-.55-.01c-.19 0-.5.07-.76.36-.26.29-1 .98-1 2.38s1.02 2.76 1.17 2.95c.15.19 2.02 3.08 4.9 4.32.68.29 1.22.47 1.63.6.69.22 1.31.19 1.81.12.55-.08 1.7-.69 1.94-1.37.24-.67.24-1.25.17-1.37-.07-.12-.26-.19-.55-.34z"/>
    <path d="M12.04 2C6.58 2 2.13 6.45 2.13 11.91c0 1.75.46 3.46 1.32 4.96L2 22l5.25-1.38c1.45.79 3.08 1.21 4.78 1.21h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2zm0 18.02h-.01c-1.52 0-3.01-.41-4.31-1.18l-.31-.18-3.2.84.85-3.12-.2-.32a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.23 8.24-8.23 2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.41 5.82c0 4.54-3.7 8.24-8.24 8.24z"/>
  </svg>
);

export const ShareButton = ({ text, url, testid = "share", dark = false }) => {
  const { t } = useLang();
  const [copied, setCopied] = useState(false);
  const shareUrl = url || (typeof window !== "undefined" ? window.location.href : "");
  const wa = `https://wa.me/?text=${encodeURIComponent(`${text}\n${shareUrl}`)}`;

  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl); setCopied(true); setTimeout(() => setCopied(false), 1600); } catch (e) {}
  };

  return (
    <div className="flex items-center gap-2">
      <a
        href={wa}
        target="_blank"
        rel="noreferrer"
        data-testid={`${testid}-whatsapp`}
        className="inline-flex items-center gap-2 h-11 px-4 rounded-full font-ui font-bold text-sm transition-transform active:scale-95 hover:scale-105"
        style={{ background: "#25D366", color: "#0B141A" }}
      >
        <WhatsAppIcon size={18} /> {t("wa_share")}
      </a>
      <button
        onClick={copy}
        data-testid={`${testid}-copy`}
        aria-label={t("link_copied")}
        className="inline-flex items-center gap-2 h-11 px-4 rounded-full font-ui font-bold text-sm transition-transform active:scale-95"
        style={dark
          ? { background: "rgba(255,255,255,0.10)", color: "var(--player-text)" }
          : { background: "var(--card)", color: "var(--text)", border: "1px solid var(--border)" }}
      >
        {copied ? <Check size={16} /> : <Copy size={16} />} {copied ? t("link_copied") : t("share")}
      </button>
    </div>
  );
};
